<template>
  <div :class="iconMenuClasses">
    <a class="app-icon-menu__inner" :href="href" @click="onClickIcon">
      <component :is="svg" class="app-icon" />
      <div v-show="hasUnReadEvent" class="app-icon-menu__event-badge" />
    </a>
    <div class="app-icon-menu__text">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppIconMenu',
  props: {
    href: {
      type: String,
      default: '#',
    },
    hasUnReadEvent: {
      type: Boolean,
      default: false,
    },
    iconPath: {
      type: String,
      default: 'top',
    },
    text: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 0,
    },
    selectedMenuIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      icons: {
        default: () => import(`../../../../../assets/images/icons/svg/${this.iconPath}.svg`),
        selected: () => import(`../../../../../assets/images/icons/svg/${this.iconPath}-selected.svg`),
      },
    };
  },
  computed: {
    iconMenuClasses() {
      return ['app-icon-menu'];
    },
    isSelected() {
      return this.selectedMenuIndex === this.index;
    },
    svg() {
      return this.isSelected ? this.icons.selected : this.icons.default;
    },
  },
  created() {
    this.loadIcons();
  },
  methods: {
    onClickIcon() {
      this.$emit('clicked-icon', this.index);
    },
    loadIcons() {
      // iconをキャッシュ
      this.icons.default();
      this.icons.selected();
    },
  },
};
</script>

<style lang="scss" scoped>
$color-red__event-badge: #ff7070;
$color-gray__text: #8c8c8c;
.app-icon-menu {
  position: relative;
  text-align: center;
  margin-bottom: 7px;
  &__inner {
    width: 42px;
    height: 42px;
    position: relative;
    display: inline-flex;
    border-radius: 50%;
  }
  &__text {
    font-size: 12px;
    line-height: 25px;
    color: $color-gray__text;
    letter-spacing: -0.1px;
  }
  &__event-badge {
    position: absolute;
    display: inline-block;
    left: 29px;
    top: -3px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: $color-red__event-badge;
  }
}
</style>
